var SLOVERS = SLOVERS || {};
(function($){

  // USE STRICT
  "use strict";
  var addToCart, addToCartFail, addToCartPass, cart_dropdown_timer, current_window, fadeOutCartDropdown, log;
  log = function(value) {
    if (typeof console !== "undefined") {
      return console.log(value);
    }
  };

  SLOVERS.initialize = {
    init: function(){
      SLOVERS.initialize.sameHeight();
      SLOVERS.initialize.megaMenu();
      SLOVERS.initialize.mainDisplayDimensions();
      SLOVERS.initialize.stickyElements();
      SLOVERS.initialize.customFunction();
      SLOVERS.initialize.swatch();
      SLOVERS.initialize.redirectFabric();
    },
    stickyElements: function(){
      if(theme.template == 'index') {}
      if(windowWidth > 1024) {
        $siteHeader.scrollToFixed({zIndex: 8 });
        if($siteHeader.hasClass('logo--center')) {
          $('.nav-section').scrollToFixed({ marginTop: $siteHeader.outerHeight(true),zIndex : 8 });
        }

      }
    },
    mainDisplayDimensions: function(){
      if( $mainDisplayEl.find('.full-image-section').length < 1 ) { return true; }
      var navspace = windowHeight / 1.77;
      if(windowWidth > 768) {
        var navspace = 85;
      }
      var firstViewHeight = windowHeight - navspace;
      $('.full-image-section').css('height', firstViewHeight);
    },
    sameHeight: function(){
      $('.same-height').matchHeight();
    },
    megaMenu: function() {
      $(".is-mega .mega-menu .item").hoverIntent(function() {
        var e = $(this), t = e.closest(".mega-menu").find(".item"), c = e.find(".mega-menu-content"),i = e.find(".mega-menu-content > .wrap");
        t.removeClass("hover"), e.addClass("hover"), c.removeClass("hide"), i.fadeIn(400, function() {
          var t = e.closest(".mega-menu").find(".item:not(.hover) .mega-menu-content > .wrap");
          t.hide()
          })
        })
    },
    redirectFabric: function(){
      var dstyp = $('main .container').data('section-type');
      if (dstyp == 'product'){
      var dsid = $('main .container').data('section-id');
      var productSingleObject = JSON.parse(document.getElementById('ProductJson-' + dsid).innerHTML);
      if(productSingleObject.type.includes('fabric')) {
        window.location.href = '/collections/fabric-gallery';
      };
      }
    },
    customFunction: function () {
      //
      $("img.lazy").lazyload({});
      // main navigation js start here
      if(windowWidth <= 1024) {
        $('.nav-parent').click(function(e) {
          e.preventDefault();
        });
      }
      $('.nav-wrapper ul li').on('mouseover', function() {
        $("body").addClass("bg-fade");
      });
      $('.nav-wrapper ul li').on('mouseleave', function() {
        $("body").removeClass("bg-fade");
      });
      // main navigation js end here
      // main navigation responsive js start here
      /*$("header .nav-toggle").click(function() {
        $("body").addClass("body-fade-mob");
        $(".menu-section").animate({'margin-left': '0px'});
      });
      $(".menu-section .mob-nav-cancel").click(function() {
        $("body").removeClass("body-fade-mob");
        $(".menu-section").animate({'margin-left': '-320px'});
      });
      */
      // main navigation responsive js start here
      // top search js start here
      $('.search-section a.top-search').on('mouseover', function() {
        $(this).parent().children(".top-search-section").addClass("current");
        $("body").addClass("body-fade");
        $(this).addClass("active");
      });
      $('.search-section').on('mouseleave', function() {
        $(".top-search-section").removeClass("current");
        $(".search-section a.top-search").removeClass("active");
        $("body").removeClass("body-fade");
      });
      // top search js end here
      // footer js for responsive start here
      if ($(window).width() < 1025 ) {
        $("footer .footer-section1 h5").click(function() {
          $(this).parent().siblings().children(".footer-col-links").slideUp();
          $(this).next(".footer-col-links").slideToggle();
        });
      }
      // sticky header start here
      $(window).scroll(function() {
        if ($(window).scrollTop() > 10 ) {
          $('#header').addClass('sticky-header');
        }
        else {
          $('#header').removeClass('sticky-header');
        }
      });
      // sticky header end here
      // fabric popup js start here
      $(".category-view-common ul li a.category-full-link").click(function(e) {
        e.preventDefault();
        SLOVERS.initialize.productPopUpOpen($(this));
        return ;
      });
      $(".popup-center .alert-popup-cancel").click(function() {
        $("body").removeClass("body-fade2");
        $("#fabrics-fetail").removeClass("active");

      });
      // fabric popup js end here

      /*
      var pInfScrLoading = false;
      var pInfScrDelay = 250;
      function pInfScrExecute() {
        var pInfScrNode = $('.more').last();
        var pInfScrURL = $('.more a').last().attr("href");
        if(pInfScrNode.length > 0 && pInfScrNode.css('display') != 'none') {
          $.ajax({
            type: 'GET',
            url: pInfScrURL,
            beforeSend: function() {
              pInfScrLoading = true;
              pInfScrNode.clone().empty().insertAfter(pInfScrNode).append('<img src=\"//cdn.shopify.com/s/files/1/0068/2162/assets/loading.gif?105791\" />');
              pInfScrNode.hide();
            },
            success: function(data) {
              // remove loading feedback
              pInfScrNode.next().remove();
              pInfScrNode.remove();
              var filteredData = $(data).find(".product");
              var filteredMoreData = $(data).find(".more");
              filteredData.insertBefore( $("#product-list-foot") );
              filteredMoreData.insertAfter( $("#product-list-foot") );
              pInfScrLoading = false;
              //$('li.singleproduct').setAllToMaxHeight();
              attachClickEvent();
            },
            dataType: "html"
          });
        }
      }
      function attachClickEvent(){
        $('.more a').click(function(event){
          pInfScrExecute();
          event.stopPropagation();
          return false;
        });
      }
      function autoScrollItem(event){
          pInfScrExecute();
          event.stopPropagation();
          return false;
      }
      attachClickEvent();
      if ($body.hasClass('template-collection')){
       $(document).ready(function () {
         $(window).scroll(function(){
             $.doTimeout( 'scroll', 200, function(){
                if($(document).height() - 800 < ($(document).scrollTop() + $(window).height())) {
                  var pInfScrNode = $('.more').last();
                  if (pInfScrNode) {
                    $('.more a').last().trigger("click");
                  }
                }
             });
         });
       });
      }
      */

    },
    productPopUpOpen:function(item) {
      var el = item.parent();
      return SLOVERS.initialize.productPopUp(el);
    },
    productPopUpClose:function() {
      $("body").removeClass("body-fade2");
      $("#fabrics-fetail").removeClass("active");
    },
    productPopUp: function(el){
      if($productPopUpEl.length > 0) {
        var element = el,
            elementProductType = element.attr('data-product-type'),
            elementProductHandle = element.attr('data-product-handle'),
            elementProductId = element.attr('data-product-id'),
            elementProductUrl= '/products/' + elementProductHandle + '.js';
        return $.getJSON(elementProductUrl, function(product) {
          var product_data, product_tags = '', product_el = product_el || {};
          if(!product.id) { return false; }
          if(product.tags.length) {
            product_tags ='<label>View alternate fabric colours:</label>';
            product_tags +='<div class="fabric-color">';
            $(product.tags).each(function( index, element ) {
              product_tags +='<a href="/collections/all/'+ element+'">'+ element +'</a> ';
            });
            product_tags +='</div>';
          }

          product_el.image_url = Shopify.resizeImage(product.featured_image, "600x600");

          product_data='<div class="alert-popup">';
          product_data+='<a onclick="SLOVERS.initialize.productPopUpClose()" class="alert-popup-cancel"><i>&nbsp;</i></a>';
          product_data+='<div class="width50 f_left">';
          product_data+='<img src="' + product_el.image_url+ '" alt="">';
          product_data+='</div>';
          product_data+='<div class="width50 f_left fabric-description">';
          product_data+='<h3>' + product.title + '</h3>';
          product_data+= product.description
          product_data+=product_tags;
          product_data+='<a href="/collections/all/'+ product.type+'" class="button">View Garments Available in this fabric</a>';
          product_data+='</div>';
          product_data+='</div>';
          $fabricsDetail.html(product_data);
          $("body").addClass("body-fade2");
          $("#fabrics-fetail").addClass("active");
          return true;
        });
      }
    },
    swatch: function() {
      // color swatch
      if ($('.swatch :radio').length) {
        $('.swatch :radio').change(function() {
          var optionIndex = $(this).closest('.swatch').attr('data-option-index');
          var optionValue = $(this).val();
          $(this).closest('form').find('.single-option-selector').eq(optionIndex).val(optionValue).trigger('change');
        });
      }
    }
  };

  SLOVERS.cart = {
    init: function() {
      SLOVERS.cart.submitForm();
      $('.recently-added.mobile .close').on('click', function() {
        return SLOVERS.cart.fadeOutCartDropdown();
      });
      $cartItem.on('click', function(e) {
        e.preventDefault();
        return SLOVERS.cart.fadeInCartDropdown();
      });
      $('.minicart-popup-cancel').on('click', function(e) {
         e.preventDefault();
        return SLOVERS.cart.fadeOutCartDropdown();
      });
      $recentlyAdded.mouseenter(function() {
        return SLOVERS.cart.stopResetTimer();
      });
      /*$recentlyAdded.mouseleave(function() {
        return SLOVERS.cart.startTimer();
      });*/
    },
    submitForm: function(){
      if( $cartForm.length > 0 ) {
        $cartForm.submit(function() {
          SLOVERS.cart.addToCart($(this));
          return false;
        });
      }
    },

    toggleCartDropdown: function() {
      return $recentlyAdded.slideToggle('fast');
    },
    slideDownCartDropdown: function() {
      $recentlyAdded.slideDown('fast');
      return $("html, body").animate({
        scrollTop: 0
      });
    },
    openMobileModal: function() {
      return $recentlyAdded.removeClass('hide').fadeIn();
    },
    fadeOutCartDropdown: function() {
      clearTimeout(cart_dropdown_timer);
      $body.removeClass('bg-fade');
      return $recentlyAdded.fadeOut('fast').addClass('hide');
    },
    fadeInCartDropdown: function() {
      clearTimeout(cart_dropdown_timer);
      return SLOVERS.cart.cartItemPopUp();
    },
    startTimer: function() {
      $body.addClass('bg-fade');
      $recentlyAdded.removeClass('hide').fadeIn();
      //$('#top-cart').addClass('top-cart-open');
      return cart_dropdown_timer = setTimeout((function() {
        return SLOVERS.cart.fadeOutCartDropdown();
      }), 4000);
    },
    stopResetTimer: function() {
      return clearTimeout(cart_dropdown_timer);
    },
    validateSize: function(cart_form) {
      if (cart_form.find('select option:selected').is(':disabled')) {
        cart_form.find('.dropdown').effect('shake', {
          'times': 2,
          'distance': 5
        }, 400);
        return false;
      }
      return true;
    },
    addToCart: function(cart_form) {
      return $.ajax({
        type: "POST",
        url: "/cart/add.js",
        dataType: "json",
        data: cart_form.serialize(),
        success: SLOVERS.cart.addToCartPass,
        error: SLOVERS.cart.addToCartFail
      });
    },
    addToCartPass: function(product) {
      return SLOVERS.cart.cartItemPopUp();
    },
    addToCartFail: function(obj, status) {
      $('.recently-added .error').show();
      $('.recently-added table').hide();
      $('.recently-added div.row').hide();
      SLOVERS.cart.slideDownCartDropdown();
      return SLOVERS.cart.startTimer();
    },
    getProductOpt: function(elementProductUrl) {
      var opt = [];
      $.ajax({
        url: elementProductUrl,
        dataType: 'json',
        async: false,
        data: {format: "json"},
        success: function(product) {
        opt = [];
          $.each(product.options, function(i, item) {
            opt.push(item.name);
          });
        }
      });
      return opt;
    },
    cartItemPopUp: function() {
      var cart_item, cart_total, imgAssetUrl;
      cart_item = {};
      cart_total = {};
      Shopify.money_format = Currency.moneyFormats[theme.shop_currency].money_format;
      return $.getJSON("/cart.js", function(cart, textStatus) {
        var new_cart_row, new_mobile_item, top_cart_items, cart_items;
        if(cart.item_count < 1){ return false; }
        imgAssetUrl = theme.imgAssetUrl.split('red')[0];
        $cartCount.html(cart_total.quantity);
        cart_items = '<a onclick="SLOVERS.cart.fadeOutCartDropdown()" class="minicart-popup-cancel"><i>&nbsp;</i></a>';
        cart_items += '<ul class="minicart-wrapper">';
        cart_total.price = Shopify.formatMoney(cart.total_price, Shopify.money_format);
        cart_total.quantity = cart.item_count;
        $( cart.items ).each(function( index, element ) {
          var product_options = '';
          cart_item.image_url = Shopify.resizeImage(cart.items[index].image, "compact");
          cart_item.image_url_mobi = Shopify.resizeImage(cart.items[index].image, "compact");
          cart_item.url = cart.items[index].url;
          cart_item.title = cart.items[index].title;
          cart_item.quantity = cart.items[index].quantity;
          cart_item.price = Shopify.formatMoney(cart.items[index].price, Shopify.money_format);
          if ($cartCount.hasClass('hide')) {
            $cartCount.removeClass('hide');
          }

          if(cart.items[index].variant_options.length) {
            var elementProductUrl= '/products/' + cart.items[index].handle + '.js';
            var items = [];
            //var opt = SLOVERS.cart.getProductOpt(elementProductUrl);
            /*var opt = [];
            $.ajax({
              url: elementProductUrl,
              dataType: 'json',
              async: false,
              data: {format: "json"},
              success: function(product) {
              opt = [];
                $.each(product.options, function(i, item) {
                  opt.push(item.name);
                });
              }
            });*/
            /*$(cart.items[index].variant_options).each(function( i, el ) {
              if(el.toLowerCase() != 'default title') {
                product_options += '<div class="col-2">';
                product_options += '<label>' + opt[i]+ '</label>';
                product_options += '<span class="filter-option" style="background-image: url('+ imgAssetUrl + el.toLowerCase().replace(/ /g,"-") +'.png);">&nbsp;</span> </div>';
              }
            });*/
            if(cart.items[index].properties != null) {
              for (var key in cart.items[index].properties){
                product_options += '<div class="col-2">';
                product_options += '<label>' + key.substring(0, 6) + '</label>';
                product_options += '<span class="filter-option" style="background-image: url('+ imgAssetUrl + cart.items[index].properties[key].replace(/ /g,"-") +'.png);">&nbsp;</span> </div>';
              }
            }
          }

          cart_items += '<li>';
          cart_items += '<div class="min-product-img"><a href="' + cart_item.url + '"><img src="' + cart_item.image_url + '" alt="' + cart_item.title + '"></a></div>';
          cart_items += '<div class="min-product-cnt">';
          cart_items += '<h2><a href="' + cart_item.url + '">' + cart_item.title.substring(0, 15) + '...</a></h2>';
          cart_items += '<div class="min-meterial">';
          cart_items += product_options;
          cart_items += '</div>';
          cart_items += '<div class="min-qty-block">';
          cart_items += '<div class="min-qty"> QTY ' + cart_item.quantity + ' </div>';
          cart_items += '<div class="min-price"> ' + cart_item.price + ' </div>';
          cart_items += '</div>';
          cart_items += '</div>';
          cart_items += '</li>';
        });
        cart_items += '</ul>';
        cart_items += '<table cellpadding="0" cellspacing="0" border="0" class="minicart-table">';
        cart_items += '<tr>';
        cart_items += '<td>Sub Total</td>';
        cart_items += '<td class="alignright">' + cart_total.price + '</td>';
        cart_items += '</tr>';
        cart_items += '<td>Total</td>';
        cart_items += '<td class="alignright">' + cart_total.price + '</td>';
        cart_items += '</tr>';
        cart_items += '</table>';
        cart_items += '<div class="button-set margin-top20">';
        cart_items += '<button onclick="window.location.href=\'/cart\'" class="button width50 f_left" title="Cart" type="button">Cart</button>';
        cart_items += '<button onclick="window.location.href=\'/checkout\'" class="button width50 f_right" title="Checkout" type="button">Checkout</button>';
        cart_items += '</div>';

        new_mobile_item = '<a href="' + cart_item.url + '">';
        new_mobile_item += '<img src="' + cart_item.image_url + '" alt="' + cart_item.title + '">';
        new_mobile_item += '</a>';
        $recentlyAdded.html(cart_items);
        $cartCount.html(cart_total.quantity);
        $('.recently-added .error').hide();
        $('.recently-added, .recently-added div.row').show();
        if ($('#header-wrap .mobile-tools').is(":hidden")) {
          SLOVERS.cart.slideDownCartDropdown();
        } else {
          SLOVERS.cart.openMobileModal();
        }
        return SLOVERS.cart.startTimer();
      });
    }
  };

  SLOVERS.widget = {
    init: function(){
      SLOVERS.widget.carousel();
      SLOVERS.widget.popup('popup');
    },
    popup: function(clazz) {
      var checkContentOverflow, closeDialog, eventListeners, fillPopupDialog, fillSizeChartDialog, getCustomClasses, getImage, getNewsletter, getPageContent, getSocialIcons, getWrapper, hideMask, ieCenter, isExpired, mask, maskIsActive, modal, modal_clazz, openDialog, passesExpiration, resetExpiration, showMask, storeExpiration;
      modal = null;
      modal_clazz = clazz;
      mask = $('.popup-modal-mask');
      storeExpiration = function() {
        var date, expires, object, seconds_from_now;
        date = new Date();
        seconds_from_now = 1000 * 60 * 60 * 24 * popup_config.days_until;
        expires = date.setTime(date.getTime() + seconds_from_now);
        object = {
          expires: expires
        };
        return localStorage[popup_config.storage_key] = JSON.stringify(object);
      };
      resetExpiration = function() {
        localStorage.removeItem(popup_config.storage_key);
        return storeExpiration();
      };
      isExpired = function() {
        var expires, now, object;
        object = JSON.parse(localStorage[popup_config.storage_key]);
        expires = object.expires;
        now = new Date().getTime();
        if (parseFloat(expires - now) <= 0) {
          resetExpiration();
          return true;
        }
        return false;
      };
      passesExpiration = function() {
        var passed;
        passed = false;
        if (Storage === "undefined" || popup_config.days_until === "test_mode") {
          passed = true;
        } else if (typeof localStorage[popup_config.storage_key] === "undefined") {
          passed = true;
          storeExpiration();
        } else {
          passed = isExpired();
        }
        return passed;
      };
      maskIsActive = function() {
        return $('.popup-modal').is(':visible') || $('.modal-mask').length > 0 && $('.modal-mask').is(':visible');
      };
      showMask = function() {
        mask.show();
        return $body.addClass("modal-on body-fade2");
      };
      hideMask = function() {
        mask.hide();
        return $body.removeClass("modal-on body-fade2");
      };
      getImage = function() {
        if (popup_config.show_image_enabled !== true) {
          return "";
        }
        if (popup_config.image_link.length > 0) {
          return $('<div class="popup-image-1 width100 f_left"><a href="' + popup_config.image_link + '"><img src="' + popup_config.show_image_url + '" alt=""></a></div>');
        } else {
          return $('<div class="popup-image-1 width100 f_left">').append("<img src='" + popup_config.show_image_url + "' alt=''>");
        }
      };
      getNewsletter = function() {
        var subscribe_module;
        if (popup_config.newsletter_enabled === false) {
          return "";
        }
        subscribe_module = $("<div id='subscribe_module' class='fotter-signup'></div>")
        .append( "<p>" + popup_config.page_content + "</p>")
        .append($("#mailing-list-module > p").clone())
        .append($("#mailing-list-module #contact_form").clone())
        .append($("#mc-embedded-subscribe-form").clone());

        return subscribe_module;
      };
      getSocialIcons = function() {
        if (popup_config.social_icons_enabled === false) {
          return "";
        }
        return $(".social-follow").clone();
      };
      getCustomClasses = function() {
        var class_list;
        class_list = "";
        class_list += popup_config.show_image_enabled === true ? " has-image" : " has-no-image";
        class_list += popup_config.page_content.length > 0 ? " has-page-content" : " has-no-page-content";
        class_list += popup_config.newsletter_enabled ? " has-newsletter" : " has-no-newsletter";
        class_list += popup_config.social_icons_enabled ? " has-social-icons" : " has-no-social-icons";
        class_list += " popup-outer active";
        return class_list;
      };
      getWrapper = function() {
        return '<dialog class="' + modal_clazz + ' popup-modal' + getCustomClasses() + '" id="homepage-newsletter" />';
      };
      getPageContent = function() {
        var page_content;
        page_content = null;
        if (popup_config.page_content.length < 1) {
          return "";
        }
        $.getJSON('/pages/' + popup_config.page_content + '.json', function(data, textStatus) {
          return page_content = "<div class='page-contents'>" + data.page.body_html + "</div>";
        });
        return page_content;
      };
      fillSizeChartDialog = function() {
        var dialog;
        if ($('.popup-modal.size-chart').length < 1) {
          dialog = {
            wrapper: getWrapper()
          };
          $body.append($(dialog.wrapper).append($('.size-chart')));
        }
        return openDialog();
      };
      fillPopupDialog = function() {
        var dialog, getInnerContent, centerPopUP, render;
        dialog = {
          wrapper: getWrapper(),
          //wrappercenter: centerPopUP(),
          newsletter: getNewsletter(),
          social_icons: getSocialIcons(),
          image: getImage()
        };
        getInnerContent = function() {
          if (popup_config.page_content.length < 1 && popup_config.newsletter_enabled === false && popup_config.social_icons_enabled === false) {
            return "";
          }
          return $("<div class='width100 f_left fabric-description' />").append(dialog.body, dialog.newsletter, dialog.social_icons);
        };
        centerPopUP = function(){
          return $('<div class="popup-center"/>').append('<div class="alert-popup" />');
        };
        render = function() {
          $body.append($(dialog.wrapper));
          $('<div class="popup-center"><div class="alert-popup"></div></div>').appendTo(".popup-outer" );
          $('.alert-popup').append(dialog.image, getInnerContent());
          return openDialog();
        };
        if (popup_config.page_content.length > 0) {
            return render();
          //return $.getJSON('/pages/' + popup_config.page_content + '.json', function(data, textStatus) {});
        } else {
          return render();
        }
      };
      checkContentOverflow = function() {
        return setTimeout((function() {
          if (modal.length > 0 && $('.popup-modal-mask').is(':visible')) {
            return modal.imagesLoaded(function() {
              if (modal.outerHeight() >= $window.height()) {
                return $body.addClass('modal-unfix');
              } else {
                return $body.removeClass('modal-unfix');
              }
            });
          }
        }), 0);
      };
      ieCenter = function() {
        return modal.css({
          marginTop: -(modal.outerHeight() * 0.5) + "px",
          marginLeft: -(modal.outerWidth() * 0.5) + "px"
        });
      };
      openDialog = function() {
        modal = $('dialog[class*="' + modal_clazz + '"]');
        if ($("html").hasClass("ie9")) {
          ieCenter();
        }
        eventListeners();
        modal.addClass("opened").removeClass("closed");
        checkContentOverflow();
        return showMask();
      };
      eventListeners = function() {
        var removeAnimation;
        removeAnimation = function(event) {
          if (event.originalEvent.animationName === 'modal-close') {
            if (modal_clazz === 'popup') {
              return modal.remove();
            } else {
              return modal.removeClass('closed, completed');
            }
          } else {
            return modal.addClass('completed').removeClass('opened');
          }
        };
        DOC.on('click', '.popup-modal', function(e) {
          e.stopPropagation();
          if (e.target === this) {
            return closeDialog();
          }
        });
        $('.popup-modal-close').click(closeDialog);
        mask.click(closeDialog);
        modal.on('animationend webkitAnimationEnd MSAnimationEnd oAnimationEnd', removeAnimation);
        $window.resize(checkContentOverflow);
        DOC.keydown(function(e) {
          if (modal.hasClass('completed') && e.keyCode === 27) {
            return closeDialog();
          }
        });
        return $('dialog.popup-modal #contact_form').on('submit', function(event) {
          var form;
          form = this;
          modal = $(this).closest('.popup-modal');
          modal.find('.error, .success').remove();
          event.preventDefault();
          if (modal.find('input[type="email"]').val().length === 0) {
            modal.find('.inner').prepend('<p class="error">' + theme.translation.newsletter_email_blank + '</p>');
            return false;
          } else {
            modal.find('.inner > *').hide();
            modal.find('.inner').prepend('<p class="success">' + theme.translation.newsletter_success_message + '</p>').show();
            setTimeout(function() {
              return form.submit();
            }, 500);
          }
          return false;
        });
      };
      closeDialog = function() {
        modal.addClass('closed').removeClass('completed').removeClass('opened').removeClass("active");
        return hideMask();
      };
      if (modal_clazz !== 'popup') {
        return fillSizeChartDialog();
      } else {
        if (popup_config.enabled && passesExpiration() && (popup_config.page_content.length > 0 || popup_config.newsletter_enabled || popup_config.show_image_enabled || popup_config.social_icons_enabled)) {
          return setTimeout((function() {
            if (!(maskIsActive() === true || $('.popup-modal-mask').length < 1)) {
              return fillPopupDialog();
            }
          }), popup_config.seconds_until * 1000);
        }
      }
    },
    carousel: function(){
      if( !$().owlCarousel ) {
        console.log('carousel: Owl Carousel not Defined.');
        return true;
      }
      var $carousel = $('.carousel-widget:not(.customjs)');
      if( $carousel.length < 1 ){ return true; }
      $carousel.each( function(){
        var element = $(this),
          elementItems = element.attr('data-items'),
          elementItemsLg = element.attr('data-items-lg'),
          elementItemsMd = element.attr('data-items-md'),
          elementItemsSm = element.attr('data-items-sm'),
          elementItemsXs = element.attr('data-items-xs'),
          elementItemsXxs = element.attr('data-items-xxs'),
          elementLoop = element.attr('data-loop'),
          elementAutoPlay = element.attr('data-autoplay'),
          elementSpeed = element.attr('data-speed'),
          elementAnimateIn = element.attr('data-animate-in'),
          elementAnimateOut = element.attr('data-animate-out'),
          elementNav = element.attr('data-nav'),
          elementPagi = element.attr('data-pagi'),
          elementMargin = element.attr('data-margin'),
          elementStage = element.attr('data-stage-padding'),
          elementMerge = element.attr('data-merge'),
          elementStart = element.attr('data-start'),
          elementRewind = element.attr('data-rewind'),
          elementSlideBy = element.attr('data-slideby'),
          elementCenter = element.attr('data-center'),
          elementLazy = element.attr('data-lazyload'),
          elementVideo = element.attr('data-video'),
          elementRTL = element.attr('data-rtl');

        if( !elementItems ) { elementItems = 4; }
        if( !elementItemsLg ) { elementItemsLg = Number(elementItems); }
        if( !elementItemsMd ) { elementItemsMd = Number(elementItemsLg); }
        if( !elementItemsSm ) { elementItemsSm = Number(elementItemsMd); }
        if( !elementItemsXs ) { elementItemsXs = Number(elementItemsSm); }
        if( !elementItemsXxs ) { elementItemsXxs = Number(elementItemsXs); }
        if( !elementSpeed ) { elementSpeed = 250; }
        if( !elementMargin ) { elementMargin = 20; }
        if( !elementStage ) { elementStage = 0; }
        if( !elementStart ) { elementStart = 0; }

        if( !elementSlideBy ) { elementSlideBy = 1; }
        if( elementSlideBy == 'page' ) {
          elementSlideBy = 'page';
        } else {
          elementSlideBy = Number(elementSlideBy);
        }

        if( elementLoop == 'true' ){ elementLoop = true; } else { elementLoop = false; }
        if( !elementAutoPlay ){
          elementAutoPlay = false;
          var elementAutoPlayTime = 0;
        } else {
          var elementAutoPlayTime = Number(elementAutoPlay);
          elementAutoPlay = true;
        }
        if( !elementAnimateIn ) { elementAnimateIn = false; }
        if( !elementAnimateOut ) { elementAnimateOut = false; }
        if( elementNav == 'false' ){ elementNav = false; } else { elementNav = true; }
        if( elementPagi == 'false' ){ elementPagi = false; } else { elementPagi = true; }
        if( elementRewind == 'true' ){ elementRewind = true; } else { elementRewind = false; }
        if( elementMerge == 'true' ){ elementMerge = true; } else { elementMerge = false; }
        if( elementCenter == 'true' ){ elementCenter = true; } else { elementCenter = false; }
        if( elementLazy == 'true' ){ elementLazy = true; } else { elementLazy = false; }
        if( elementVideo == 'true' ){ elementVideo = true; } else { elementVideo = false; }
        if( elementRTL == 'true' || $body.hasClass('rtl') ){ elementRTL = true; } else { elementRTL = false; }

        element.owlCarousel({
          margin: Number(elementMargin),
          loop: elementLoop,
          stagePadding: Number(elementStage),
          merge: elementMerge,
          startPosition: Number(elementStart),
          rewind: elementRewind,
          slideBy: elementSlideBy,
          center: elementCenter,
          lazyLoad: elementLazy,
          nav: elementNav,
          navText: ['<i class="icon-angle-left"></i>','<i class="icon-angle-right"></i>'],
          autoplay: elementAutoPlay,
          autoplayTimeout: elementAutoPlayTime,
          autoplayHoverPause: true,
          dots: elementPagi,
          smartSpeed: Number(elementSpeed),
          fluidSpeed: Number(elementSpeed),
          video: elementVideo,
          animateIn: elementAnimateIn,
          animateOut: elementAnimateOut,
          rtl: elementRTL,
          responsive:{
            0:{ items:Number(elementItemsXxs) },
            480:{ items:Number(elementItemsXs) },
            768:{ items:Number(elementItemsSm) },
            992:{ items:Number(elementItemsMd) },
            1200:{ items:Number(elementItemsLg) }
          },
          onInitialized: function(){
            SLOVERS.widget.owlCaptionInit();
          }
        });
      });
    },
    owlCaptionInit: function(){
      if( $owlCarouselEl.length > 0 ){
        $owlCarouselEl.each( function(){
          var element = $(this);
          if( element.find('.owl-dot').length > 0 ) {
            element.addClass('with-carousel-dots');
          }
        });
      }
    }
  };

  SLOVERS.documentOnResize = {
    init: function(){
      var t = setTimeout( function(){
        SLOVERS.initialize.mainDisplayDimensions();
        SLOVERS.initialize.sameHeight();
      }, 500 );
      windowWidth = $window.width(),
      windowHeight= $window.height();
    }
  };

  SLOVERS.documentOnReady = {
    init: function(){
      SLOVERS.initialize.init();
      SLOVERS.cart.init();
      SLOVERS.widget.init();
    }
  };

  SLOVERS.documentOnLoad = {
    init: function(){
      //SLOVERS.initialize.stickyElements();
    }
  };

  var $window = $(window),
    $body = $('body'),
    DOC = $(document),
    $wrapper = $('#wrapper'),
    $header = $('.site-header'),
    $headerWrap = $('#header-wrap'),
    $siteHeader= $('.site-header'),
    $pageContainer= $('#PageContainer'),
    $content = $('#content'),
    $container = $('.container'),
    $productPopUpEl = $('.product-popup'),
    $fabricsDetail = $('.fabricsDetail'),
    $cartForm = $('.cart-form'),
    $cartCount = $('.cart-count'),
    $cartItem = $('.cart-item'),
    $owlCarouselEl = $('.owl-carousel'),
    $recentlyAdded = $('.recently-added'),
    $miniCartPopupCancel = $('.minicart-popup-cancel'),
    $footer = $('#footer'),
    windowWidth = $window.width(),
    windowHeight= $window.height(),
    $mainDisplayEl = $('.main-display');
  $(document).ready( SLOVERS.documentOnReady.init );
  $window.load( SLOVERS.documentOnLoad.init );
  $window.on( 'resize', SLOVERS.documentOnResize.init );
})(jQuery);
